import { IResponsive } from '../types/IResponsive';

export function getResponsiveFallback<TType extends string | number | symbol> (responsive: IResponsive<TType>, key: keyof IResponsive<TType>): TType | undefined {
    const fallbacks: Array<TType | undefined> = [
        responsive.sm,
        responsive.md,
        responsive.lg,
    ];

    let startingIndex: number = 0;

    if (key === 'md') {
        startingIndex = 1;
    }

    if (key === 'lg') {
        startingIndex = 2;
    }

    for (let i = startingIndex; i >= 0; i = i - 1) {
        if (fallbacks[i] !== undefined) {
            return fallbacks[i];
        }
    }

    return undefined;
}
